type Q = {
    on: () => Q;
    otherwise: () => void;
};

type R<V> = {
    on: (predicate: (value: V) => boolean, fn: (value: V) => void) => R<V> | Q;
    otherwise: (fn: (value: V) => void) => void;
};

const matched = <T>(value: T): Q => ({
    on: () => matched(value),
    otherwise: () => value,
});

const f = <T>(value: T): R<T> => ({
    on: (predicate, fn) => (predicate(value) ? matched(fn(value)) : f(value)),
    otherwise: (fn) => fn(value),
});

export default f;
